<template>
  <div
    class="dark:bg-ontick-graphite-500 absolute inset-0 z-20 flex transform cursor-pointer items-center justify-center overflow-hidden rounded-lg bg-[#E9EAEB] bg-opacity-90 text-center backdrop-blur-sm backdrop-filter dark:bg-opacity-90 dark:backdrop-blur-sm dark:backdrop-filter"
    @click="close"
    v-if="mask.type != 'FIRST_PLAY'"
  >
    <div class="absolute top-4 right-4">
      <i v-html="$icons.modalCloseButton"></i>
    </div>
    <div
      :class="
        getVisualizationMode === 'list'
          ? 'flex items-center justify-center space-x-2'
          : 'block space-y-2 p-5 pb-4'
      "
    >
      <i
        v-html="maskData[maskIndex].icon"
        class="flex justify-center"
        :class="{ 'scale-50 transform': getVisualizationMode === 'list' }"
      ></i>
      <p
        class="text-ontick-carbon-900 font-bold dark:text-gray-200"
        :class="
          getVisualizationMode === 'list' ? 'text-normal' : 'mt-2 text-lg'
        "
      >
        {{ maskData[maskIndex].title }}
      </p>
      <p
        v-if="
          getVisualizationMode === 'card' && maskData[maskIndex].description
        "
        class="card_mask_description"
      >
        {{ maskData[maskIndex].description }}
      </p>
      <template v-if="mask.result">
        <p class="card_mask_data">
          Resultado:
          <strong class="">{{ mask.result | currency }}</strong>
        </p>
      </template>
    </div>
    <!--  -->
    <div v-if="!mask.fixedMask" class="absolute bottom-0 w-full">
      <div
        class="transition-all duration-200"
        :class="[timer, 'h-1']"
        :style="`width:${count}%`"
      >
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import { mapGetters } from "vuex";
export default {
  name: "card-mask",

  props: {
    mask: {
      type: Object,
    },
  },

  data() {
    return {
      max: 100,
      value: 0,
      count: 100,
      interval: null,
      maskData: [
        {
          id: 0,
          type: "NEW_POSITION",
          icon: icons.aberturaPosicao,
          title: "Abertura de posição",
          description:
            "Sua estratégia abriu posição e já está operando. Bons investimentos!",
        },
        {
          id: 1,
          type: "GAIN_LIMIT",
          icon: icons.metaAtingida_Ganho,
          title: "Meta atingida",
          description:
            "Sua estratégia atingiu a meta de lucro diário e não irá mais operar no dia de hoje.",
        },
        {
          id: 2,
          type: "STOP_LOSS",
          icon: icons.stopLoss,
          title: "Stop loss",
          data: {
            result: -50,
            status: "BUY",
            time: "15:03:35",
          },
        },
        {
          id: 3,
          type: "PARTIAL_GAIN",
          icon: icons.realizacaoParcial,
          title: "Realização parcial",
        },

        {
          id: 4,
          type: "LOSS_LIMIT",
          icon: icons.metaAtingida_Perda,
          title: "Meta atingida",
          description:
            "Sua estratégia atingiu a meta de perda diária e não irá mais operar no dia de hoje.",
        },
        {
          id: 5,
          type: "TAKE_PROFIT",
          icon: icons.takeProfit,
          title: "Take profit",
          data: {
            result: 150,
            status: "SELL",
            time: "15:03:35",
          },
        },
        {
          id: 6,
          type: "TRADES_LIMIT",
          icon: icons.limiteOperacoes,
          title: "Limite de operações",
          description:
            "Sua estratégia atingiu o limite de operações e não irá mais operar no dia de hoje.",
        },
        {
          id: 7,
          type: "TIME_LIMIT",
          icon: icons.timeLimit,
          title: "Horário limite",
          description:
            "Sua estratégia atingiu o horário limite para operações e não irá mais operar no dia de hoje.",
        },
        {
          id: 8,
          type: "FIRST_PLAY",
          icon: icons.comeceInvestir,
          title: "Comece a investir!",
          description:
            "Essa estratégia ainda não foi iniciada. Clique aqui para começar a investir.",
        },
        {
          id: 9,
          type: "BREAKEVEN",
          icon: icons.breakeven,
          title: "Breakeven",
          description:
            "Uma alteração de stop loss acabou de ocorrer nessa estratégia.",
        },
        {
          id: 10,
          type: "REVERSAL",
          icon: icons.viradaMao,
          title: "Virada de mão",
          description:
            "Essa estratégia acabou de reverter o sentido de sua operação.",
        },
        {
          id: 11,
          type: "EXTERNAL_ACTION",
          icon: icons.interferencia,
          title: "Interferência externa",
          description:
            "Interferência detectada. Não será mais possível executar a estratégia no dia de hoje.",
        },
        {
          id: 12,
          type: "REJECTED_ORDER",
          icon: icons.ordemRejeitada,
          title: "Ordem rejeitada",
          description: "Encontramos um problema para executar esta estratégia.",
        },
        {
          id: 13,
          type: "POSITION_CLOSE",
          icon: icons.aberturaPosicao,
          title: "Posição fechada",
          description: "Sua estratégia fechou uma posição.",
        },
      ],
    };
  },

  methods: {
    progress() {
      if (!this.mask.fixedMask) {
        this.interval = setInterval(() => {
          if (this.count === 0) {
            this.close();
            clearInterval(this.interval);
          } else {
            this.count -= 1;
          }
        }, 100);
      }
    },
    close() {
      clearInterval(this.interval);
      this.$emit("close");
    },
  },

  computed: {
    ...mapGetters({ getVisualizationMode: "investment/getVisualizationMode" }),
    maskIndex() {
      let index = this.maskData.findIndex(
        (item) => item.type === this.mask.type
      );
      return index;
    },
    timer() {
      return {
        "bg-ontick-blue-600": this.mask.type == "NEW_POSITION",
        "bg-ontick-red-600":
          this.mask.type == "STOP_LOSS" || this.mask.type === "REJECTED_ORDER",
        "bg-ontick-green-600":
          this.mask.type == "PARTIAL_GAIN" || this.mask.type == "TAKE_PROFIT",

        "bg-[#D7C94E]": this.mask.type == "TRADES_LIMIT",
        "bg-[#336179]": this.mask.type == "TIME_LIMIT",
        "bg-ontick-graphite-300":
          this.mask.type == "BREAKEVEN" || this.mask.type == "REVERSAL",
      };
    },
  },

  created() {
    this.progress();
  },
};
</script>

<style lang="scss" scoped>
@import "./card-mask.component.scss";
</style>
